import { render, staticRenderFns } from "./SelectDesc.vue?vue&type=template&id=355167a2"
import script from "./SelectDesc.vue?vue&type=script&lang=js"
export * from "./SelectDesc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('355167a2')) {
      api.createRecord('355167a2', component.options)
    } else {
      api.reload('355167a2', component.options)
    }
    module.hot.accept("./SelectDesc.vue?vue&type=template&id=355167a2", function () {
      api.rerender('355167a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/template/SelectDesc.vue"
export default component.exports